import React from 'react'
import reactCSS from 'reactcss'
import {SketchPicker} from 'react-color'
import {Popover} from "antd";

class ColorPicker extends React.Component {
  state = {
    displayColorPicker: false,
  };

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  };

  render() {

    const styles = reactCSS({
      'default': {
        color: {
          width: '36px',
          height: '14px',
          borderRadius: '2px',
          background: this.props.color,
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });

    const popoverContent = (
        <>
          <div style={ styles.cover } onClick={ this.handleClose }/>
          <SketchPicker
              presetColors={this.props.presetColors}
              color={ this.props.color }
              onChange={ this.props.onChange }
          />
        </>
    );

    return (
        <div>
          <Popover
              overlayClassName={'pure-popover'}
              visible={this.state.displayColorPicker}
              trigger={[]}
              placement={'bottomLeft'}
              content={popoverContent}
          >
            <div style={ styles.swatch } onClick={ this.handleClick }>
              <div style={ styles.color } />
            </div>
          </Popover>
        </div>
    );
  }
}

export default ColorPicker
